import { SearchBox } from "@/features/search/components/search-box/SearchBox";
import { SearchBoxRecents } from "@/features/search/components/search-box/SearchBoxRecents";
import { SearchBoxSuggestions } from "@/features/search/components/search-box/SearchBoxSuggestions";

/**
 * The header's search box — the one place that decides which sections the dropdown has and in what
 * order. Every section reads its own state, so adding saved searches or reordering these is a change
 * to this file alone.
 *
 * The order holds for both states: while typing it reads term → suggestions (recents hide
 * themselves), and while empty it reads recents → trending.
 */
export const HeaderSearchBox = () => (
  <SearchBox.Root className="min-w-0">
    <SearchBox.Input />
    <SearchBox.Panel>
      <SearchBox.Term />
      <SearchBoxRecents />
      <SearchBoxSuggestions />
      <SearchBox.Empty />
    </SearchBox.Panel>
  </SearchBox.Root>
);
